module.exports = __webpack_public_path__ + "img/savology-wf-7.6ba0fcb3.jpg";